<template>
  <CFooter :fixed="false">
    <div>
      <a href="https://raymas.in" target="_blank">Raymas</a>
      <span class="ml-1">&copy; {{new Date().getFullYear()}} Team Manakkal OMS 3.0 </span>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
